var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "026555e08f76323a17758f8d43cdbc95bf26ea05"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dodo-landing-page@delivery-hero-pm"] = {
  id: "026555e08f76323a17758f8d43cdbc95bf26ea05"
};